// src/config/featureFlags.js
// Feature flags for feed personalization and language preferences

export const FEED_ENABLE = true;      // master switch for feed-time personalization
export const FEED_WLANG = 0.15;       // weight for language score in RecommendationEngine
export const LANG_HALF_LIFE_MIN = 15; // short-term delta half-life in minutes
export const LANG_TOP_K = 2;          // how many top languages to surface to client code
